import React from "react";

const DATE_RE = /^\d{4}-\d{2}-\d{2}$/;

function formatUtcDate(value) {
  if (typeof value !== "string" || !DATE_RE.test(value)) return null;
  const [year, month, day] = value.split("-").map(Number);
  const date = new Date(Date.UTC(year, month - 1, day));
  if (
    date.getUTCFullYear() !== year ||
    date.getUTCMonth() !== month - 1 ||
    date.getUTCDate() !== day
  ) {
    return null;
  }
  return date.toLocaleDateString("en-US", {
    timeZone: "UTC",
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

export default function BillingTrialPeriod({ trialPeriod }) {
  if (trialPeriod == null) return null;
  const started = formatUtcDate(trialPeriod.started_on);
  const ends = formatUtcDate(trialPeriod.ends_on);
  if (started == null || ends == null) return null;

  let text = null;
  if (trialPeriod.status === "active") {
    text = `Trial started ${started}. Trial ends ${ends}.`;
  } else if (trialPeriod.status === "ended") {
    text = `Trial period ended. It started ${started} and ended ${ends}.`;
  }
  if (text == null) return null;

  return (
    <p className="text-sm text-[#F3F4F6]" data-testid="billing-trial-period">
      {text}
    </p>
  );
}
